// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3kyhF","legacyBtn":"MutateMid_legacyBtn__18Pi7"};